const CONTENT_TYPE_CODE = {
  REELS_RAW: 1,
  REELS_PUBLISHED: 2,
  REELS_INSPECTION_INITIAL: 3,
  REELS_INSPECTION_FIXED: 4,
}

const POSTING_VIDEO = {
  CONTENT_TYPE_CODE,
}

export default POSTING_VIDEO
